import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { getNewFileFormGroup } from '@app/helpers/form.helper';
import { FileUploadControl } from '@app/models/form.models';
import { ProjectSetupCreateRequest } from '@app/models/project.models';
import { FileType } from '@app/models/shared.enums';

export interface NewProjectFormGroup {
  country: FormControl<string>;
  city: FormControl<string>;
  collectionCurrency: FormControl<string>;
  projectTitle: FormControl<string>;
  projectIntroduction: FormControl<string>;
  files: FormArray<FormGroup<FileUploadControl>>;
}

export function getNewProjectFormGroup(
  fb: FormBuilder
): FormGroup<NewProjectFormGroup> {
  return fb.nonNullable.group({
    country: fb.nonNullable.control<string>('', [Validators.required]),
    city: fb.nonNullable.control<string>('', [Validators.required]),
    collectionCurrency: fb.nonNullable.control<string>('', [
      Validators.required,
    ]),
    projectTitle: fb.nonNullable.control<string>('', [
      Validators.required,
      Validators.minLength(3),
    ]),
    projectIntroduction: fb.nonNullable.control<string>('', [
      Validators.required,
    ]),
    files: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.document),
    ]),
  });
}

export function convertFormToProjectIdeaInput(
  form: FormGroup<NewProjectFormGroup>
): ProjectSetupCreateRequest {
  return {
    name: form.controls.projectTitle.value,
    currency: form.controls.collectionCurrency.value,
    country: form.controls.country.value,
    city: form.controls.city.value,
    description: form.controls.projectIntroduction.value,
  };
}
